module.exports = __webpack_public_path__ + "static/img/1.49e14c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/pintu/1.jpg
// module id = JuSL
// module chunks = 1